// extracted by mini-css-extract-plugin
module.exports = {"autoprolong":"_927a99ad28--autoprolong--QRXgP","autoprolong_hint":"_927a99ad28--autoprolong_hint--_2fgr"};